import { useMemo } from 'react';
import useAuth from "../routes/login/AuthContext";
import uniqBy from 'ramda/es/uniqBy';
import prop from 'ramda/es/prop';
import { 
  IS_ACC_ORIGIN,
  IS_CARDINAL_ORIGIN,
  IS_GMH_ORIGIN,
  IS_LANDMARK_ORIGIN,
  IS_TDC_ORIGIN,
  IS_PEAKMADE_ORIGIN
} from "../constants/general";
import { useNetworksContext } from "../contexts/NetworksProvider";

export const useUserPermissions = () => {
  const { isSuperAdmin } = useAuth();
  const { networks } = useNetworksContext();
  const networksLength = useMemo(() => uniqBy(prop('l1Id'), networks).length, [networks]);

  let readOnly = false;

  const isMoreThan4Networks = networksLength >= 4;
  const isMoreThan5Networks = networksLength >= 5;
  const isMoreThan10Networks = networksLength >= 10;
  const isMoreThan20Networks = networksLength >= 20;
  const isMoreThan50Networks = networksLength >= 50;
  const isAcc = IS_ACC_ORIGIN;
  const isCardinal = IS_CARDINAL_ORIGIN;
  const isGmh = IS_GMH_ORIGIN;
  const isLandmark = IS_LANDMARK_ORIGIN;
  const isTdc = IS_TDC_ORIGIN;
  const isPeakmade = IS_PEAKMADE_ORIGIN;;
  
  if(isGmh || isTdc) {
    const hasAccess = isMoreThan5Networks;

    readOnly = !hasAccess;
  }

  if (isLandmark) {
    const hasAccess = isMoreThan20Networks;

    readOnly = !hasAccess;
  }

  if (isAcc) {
    const hasAccess = isMoreThan10Networks || isSuperAdmin();

    readOnly = !hasAccess;
  }

  if( isPeakmade) {
    const hasAccess = isMoreThan4Networks || isSuperAdmin();

    readOnly =!hasAccess;
  }

  if (isCardinal) {
    const hasAccess = isMoreThan50Networks || isSuperAdmin();

    readOnly = !hasAccess;
  }

  return ({
    readOnly,
    isLandmark,
    isCardinal,
    isPeakmade
  });
};
